var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { html, LitElement, nothing } from "lit";
import { property } from "lit/decorators.js";
import { reset } from "../styles.js";
import { styles } from "./styles.js";
const variants = [
    "primary",
    "secondary",
    "negative",
    "negativeQuiet",
    "utility",
    "utilityQuiet",
    "quiet",
    "link",
    "overlay",
    "overlayInverted",
    "overlayQuiet",
    "overlayInvertedQuiet",
];
/**
 * Link component to use when creating links that look like buttons.
 *
 * [Warp component reference](https://warp-ds.github.io/docs/components/link/frameworks/elements)
 */
class WarpLink extends LitElement {
    constructor() {
        super(...arguments);
        /**
         * Focus the link after it is rendered
         */
        this.autofocus = false;
        /**
         * Render a smaller version
         */
        this.small = false;
        /**
         * Applies disabled styling, but you need to disable clicks on your own.
         *
         * The component renders an `<a>` element; `disabled` affects styling, but does not inherently prevent navigation. If you need to fully disable interaction, omit `href` and/or prevent default click behavior.
         */
        this.disabled = false;
        /**
         * Makes the link take up the full width of its parent
         */
        this.fullWidth = false;
    }
    /** @internal */
    static { this.shadowRootOptions = {
        ...LitElement.shadowRootOptions,
        delegatesFocus: true,
    }; }
    static { this.styles = [reset, styles]; }
    connectedCallback() {
        super.connectedCallback();
        // Validate variant if explicitly set
        if (this.variant && !variants.includes(this.variant)) {
            throw new Error(`Invalid "variant" attribute. Set its value to one of the following:\n${variants.join(", ")}.`);
        }
    }
    firstUpdated() {
        if (this.autofocus) {
            setTimeout(() => this.focus(), 0);
        }
    }
    render() {
        return html `
			<a
				href="${this.href}"
				part="base"
				target="${this.target}"
				rel="${this.target === "_blank" ? this.rel || "noopener" : nothing}"
				tabindex="0"
			>
				<slot></slot>
			</a>
		`;
    }
}
__decorate([
    property({ type: Boolean, reflect: true })
], WarpLink.prototype, "autofocus", void 0);
__decorate([
    property({ reflect: true })
], WarpLink.prototype, "variant", void 0);
__decorate([
    property({ type: Boolean, reflect: true })
], WarpLink.prototype, "small", void 0);
__decorate([
    property({ reflect: true })
], WarpLink.prototype, "href", void 0);
__decorate([
    property({ type: Boolean, reflect: true })
], WarpLink.prototype, "disabled", void 0);
__decorate([
    property({ reflect: true })
], WarpLink.prototype, "target", void 0);
__decorate([
    property({ reflect: true })
], WarpLink.prototype, "rel", void 0);
__decorate([
    property({ attribute: "full-width", type: Boolean, reflect: true })
], WarpLink.prototype, "fullWidth", void 0);
if (!customElements.get("w-link")) {
    customElements.define("w-link", WarpLink);
}
export { WarpLink };
//# sourceMappingURL=link.js.map